import { createResource, getResource, postgRESTApiUrl, readUrlObjectBased } from "./api";

// Caps the id list on one batched title fetch, so a pathological saved set can't build an
// unbounded PostgREST filter.
export const PUBLIC_PITCH_TITLES_LIMIT = 1000;

// Reads the enrich-scored "public pitches" examples that named this expert PromoEntity as one of
// the entities pitched, for the profile's Story Ideas card. `pitched_promo_entity_ids` is a native
// Postgres array column (not the jsonb columns some other views expose id sets through), so
// PostgREST's "contains" filter needs the Postgres array-literal `{id}` value — the same syntax
// the pitch-library panel already uses against the sibling `pitches` view — rather than the bare
// scalar a jsonb-typed column would accept.
const getAllForExpert = async (promoEntityId) => {
  const url = readUrlObjectBased("public_pitches", {
    conditionParams: {
      pitched_promo_entity_ids: `cs.{${promoEntityId}}`,
      order: "score.desc",
    },
  });
  return getResource(url);
};

// Titles and author details for a set of public pitches by id, from the `public_pitches` view.
// profile_slug links the author on V2; profile_id maps (via the user_profiles API) to the V1 User
// id the byline links to when this component is hosted by V1. Returns
// { data: [{ id, title, profile_name, profile_slug, profile_id }], error }.
const fetchTitlesByIds = async (ids) => {
  if (!ids || ids.length === 0) return { data: [] };

  const capped = ids.slice(0, PUBLIC_PITCH_TITLES_LIMIT);
  const params = new URLSearchParams([
    ["select", "id,title,profile_name,profile_slug,profile_id"],
    ["id", `in.(${capped.join(",")})`],
    ["limit", String(PUBLIC_PITCH_TITLES_LIMIT)],
  ]);
  return getResource(`${postgRESTApiUrl()}/rest/v1/public_pitches?${params}`);
};

// The enrich text_transformation endpoint caps its input at this many characters.
export const PITCH_TO_REQUEST_TEXT_LIMIT = 2048;

// Rewrites a story idea's expert-voice text into a reporter's call for sources.
// Returns { data: { result: { title, details } } } or { error }.
const transformToRequest = async (text) =>
  createResource("/enrich/api/text_transformation", {
    transformation_type: "pitch_to_request",
    text: text.slice(0, PITCH_TO_REQUEST_TEXT_LIMIT),
  });

export default { getAllForExpert, fetchTitlesByIds, transformToRequest };
